import React from 'react';

function RedoIcon() {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='24'
			height='24'
			fill='none'
			viewBox='0 0 24 24'
		>
			<path
				stroke='#141414'
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeWidth='1.5'
				d='M13 18H8.5a4.5 4.5 0 110-9H20'
			></path>
			<path
				stroke='#141414'
				strokeLinecap='round'
				strokeLinejoin='round'
				strokeWidth='1.5'
				d='M17 12s3-2.21 3-3-3-3-3-3'
			></path>
		</svg>
	);
}

export default RedoIcon;
